import PropTypes from 'prop-types'

import {Text, Flex} from '@chakra-ui/react'

const SubsectionTitle = ({title, children}) => {
  return (
    <Flex
      justify="space-between"
      flexWrap="wrap"
      flexDirection={{base: 'column', sm: 'row'}}
    >
      <Text
        as="h5"
        role="heading"
        textStyle="headline5"
        textTransform="uppercase"
        fontWeight="medium"
        pb="xs"
      >
        {title}
      </Text>
      {children}
    </Flex>
  )
}

SubsectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
}

SubsectionTitle.defaultProps = {
  children: null,
}

export default SubsectionTitle
